import {
  FETCH_TRANSFER_ORDER_LIST_PENDING,
  FETCH_TRANSFER_ORDER_LIST_REJECTED,
  FETCH_TRANSFER_ORDER_LIST_FULFILLED,
  START_TRANSFER_ORDER_LIST_AUTO_RELOAD,
  STOP_TRANSFER_ORDER_LIST_AUTO_RELOAD,
  SET_ACTIVE_STATUS_FOR_TRANSFER_ORDER_LIST,
  CLEAR_TRANSFER_ORDER_LIST
} from "../constants/transferOrderList";

const initialState = {
  pending: true,
  transferOrders: [],
  autoReloadIntervalId: null,
  activeStatusId: null,
  error: {},
};

export const transferOrderList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRANSFER_ORDER_LIST_PENDING:
      return { ...state, pending: true, error: [] };

    case FETCH_TRANSFER_ORDER_LIST_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_TRANSFER_ORDER_LIST_FULFILLED:
      return {
        ...state,
        transferOrders: action.data.results,
        pending: false,
        error: []
      };

    case START_TRANSFER_ORDER_LIST_AUTO_RELOAD:
      return {
        ...state,
        autoReloadIntervalId: action.data,
      }

    case STOP_TRANSFER_ORDER_LIST_AUTO_RELOAD:
      return {
        ...state,
        autoReloadIntervalId: null,
      }

    case SET_ACTIVE_STATUS_FOR_TRANSFER_ORDER_LIST:
      return {
        ...state,
        activeStatusId: action.data,
      }

    case CLEAR_TRANSFER_ORDER_LIST:
      const { activeStatusId } = state;
      return {
        ...initialState,
        ...({ activeStatusId } || {})
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/transferOrderList.js